import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { OnBoardingService } from 'services';
import { NewJoinerTask } from '../types';
import BaseAction from 'redux/actions/baseAction';
import { useUserData } from 'hooks';
import onBehalfAction from 'redux/actions/onBehalfAction';

const STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
};

const useNewJoinerOrderTask = () => {
  const dispatch = useDispatch();
  const currentUser = useUserData();
  const { isOnBehalf } = useSelector((state: RootState) => state.onBehalfReducer);
  const { generalConfig } = useSelector((state: RootState) => state.configReducer);
  const orderTaskDefinitionId = generalConfig?.newJoiner?.orderTaskDefinitionId || '';

  const [orderTask, setOrderTask] = useState<NewJoinerTask | undefined>();

  const isOrderAllowed = useMemo(() => {
    if (!currentUser?.new_joiner) return true;
    if (!orderTask) return false;
    return orderTask.status !== STATUS.COMPLETED;
  }, [currentUser, orderTask]);

  useEffect(() => {
    if (currentUser?.task && orderTaskDefinitionId) {
      const orderTask = currentUser.task.find((task: NewJoinerTask) => {
        return task?.task_definition_id === orderTaskDefinitionId;
      });
      setOrderTask(orderTask);
    }
  }, [currentUser, orderTaskDefinitionId]);

  const completeOrderTask = async () => {
    if (!currentUser?.new_joiner || !orderTask) return;

    try {
      const res = await OnBoardingService.updateNewJoinerTasks([
        { id: orderTask.id!, status: STATUS.COMPLETED },
      ]);
      if (res.success) {
        const newUser = await OnBoardingService.getNewJoinerInfo(currentUser.email);
        const updatedUser = { ...currentUser, ...newUser.data };
        if(isOnBehalf){
          dispatch(onBehalfAction.setUserOnBehalfOf(updatedUser));
        }
        else{
          dispatch(BaseAction.setCurrentUserSuccess(updatedUser));
        }
      }
    } catch (error) {
      console.error('Failed to completed order task', error);
    }
  };

  return {
    isOrderAllowed,
    orderTaskDefinitionId,
    orderTask,
    completeOrderTask,
  };
};

export default useNewJoinerOrderTask;
